/** Landmark index — every monument in the set, shown in both approved
 * colourways on the tile washes. A review + reference surface (reachable
 * at /monuments); the tiles themselves pick from the same set. */
import { Link } from "react-router-dom";
import { useT } from "../../../i18n";
import { tileBackground } from "../tileArt";
import { MONUMENTS } from "./manifest";
import { MonumentIcon } from "./registry";

const SHADOW = "drop-shadow-[0_4px_6px_rgb(var(--color-ink)/0.4)]";

export function MonumentGalleryPage() {
  const t = useT();
  return (
    <div className="space-y-6">
      <div>
        <Link to="/practice" className="text-sm text-muted hover:text-brand">
          ← {t("practice.title")}
        </Link>
        <h1 className="mt-1 text-3xl font-extrabold">{t("monuments.title")}</h1>
        <p className="mt-1 text-muted">
          {MONUMENTS.length} {t("monuments.subtitle")}
        </p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5">
        {MONUMENTS.map((m, i) => (
          <div key={m.key} className="overflow-hidden rounded-card border border-line bg-surface">
            {/* mobile-ok: two halves of one card tile, checked on a 390px screen —
                the icon and its caption belong side by side at every width. */}
            <div className="grid grid-cols-2">
              <div
                className="grid aspect-square place-items-center"
                style={{ background: tileBackground(((i % 3) * 2) + 1) }}
              >
                <MonumentIcon monumentKey={m.key} colorway="sandGold" className={`h-full w-full p-3 ${SHADOW}`} />
              </div>
              <div
                className="grid aspect-square place-items-center"
                style={{ background: tileBackground((((i + 1) % 3) * 2) + 2) }}
              >
                <MonumentIcon monumentKey={m.key} colorway="cobalt" className={`h-full w-full p-3 ${SHADOW}`} />
              </div>
            </div>
            <div className="p-2 text-center">
              <p className="truncate text-xs font-bold text-ink">{m.name}</p>
              <p className="text-[10px] text-muted">{m.city}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
